(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lx3-collection-structure"] && !Shopify.designMode) return;
  try {
    
function initLX3(root){if(root.dataset.ready)return;root.dataset.ready='true';let category='All';const cards=[...root.querySelectorAll('[data-card]')];function filter(){root.querySelectorAll(".ed-motion").forEach(x=>x.hidden=category!=="All");let count=0;cards.forEach(c=>{const show=(category==='All'||c.dataset.category===category);c.hidden=!show;if(show)count++});root.querySelector('[data-count]').textContent=String(count);root.querySelector('[data-empty]').hidden=count!==0}root.querySelectorAll('[data-filter]').forEach(b=>b.addEventListener('click',()=>{category=b.dataset.filter;root.querySelectorAll('[data-filter]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));filter()}));root.querySelectorAll('[data-open]').forEach(b=>b.addEventListener('click',()=>{const d=root.querySelector('[data-detail="'+b.dataset.open+'"]');if(d)d.showModal()}));root.querySelectorAll('dialog').forEach(d=>{d.querySelector('[data-close]').addEventListener('click',()=>d.close());d.addEventListener('click',e=>{if(e.target===d){const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)d.close()}})});filter()}document.querySelectorAll('.lx3-structure').forEach(initLX3);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.lx3-structure').forEach(initLX3));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx3-launch"] && !Shopify.designMode) return;
  try {
    
function initLX3Film(root){
 if(root.dataset.filmReady)return;const v=root.querySelector('video');if(!v)return;root.dataset.filmReady='true';
 const reduced=matchMedia('(prefers-reduced-motion: reduce)'),mobile=matchMedia('(max-width:700px)'),connection=navigator.connection;
 const shouldPlay=()=>!reduced.matches&&!(connection&&connection.saveData);
 let loaded=false;
 const stop=()=>{v.pause();v.hidden=true;v.removeAttribute('src');v.load();loaded=false};
 const start=()=>{if(!shouldPlay()){stop();return}if(!loaded){v.src=mobile.matches?v.dataset.mobileSrc:v.dataset.desktopSrc;loaded=true}v.muted=true;v.defaultMuted=true;v.play().catch(()=>{v.hidden=true})};
 v.addEventListener('playing',()=>{v.hidden=false});
 v.addEventListener('timeupdate',()=>{if(!v.paused&&v.duration>16.5&&v.duration<17.5&&v.currentTime>=13.5)v.currentTime=0});
 reduced.addEventListener('change',start);if(connection)connection.addEventListener('change',start);
 mobile.addEventListener('change',()=>{stop();start()});
 document.addEventListener('visibilitychange',()=>{if(document.hidden)v.pause();else start()});
 if(shouldPlay()){if('requestIdleCallback' in window)requestIdleCallback(start,{timeout:1000});else setTimeout(start,250)}
}
document.querySelectorAll('.lx3-launch').forEach(initLX3Film);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.lx3-launch').forEach(initLX3Film));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx3-product"]) return;
  try {
    
document.querySelectorAll('.lx3-buy-form').forEach(form=>{
  form.addEventListener('change',event=>{
    if(!event.target.matches('input[name="id"]'))return;
    const price=form.closest('.lx3-product-info').querySelector('.lx3-product-price');
    if(price&&event.target.dataset.price)price.textContent=event.target.dataset.price;
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx3-search"]) return;
  try {
    
document.querySelectorAll('.lx3-search-input').forEach(input=>{
  const root=input.closest('.lx3-store');
  const cards=[...root.querySelectorAll('[data-search]')];
  const status=root.querySelector('#lx3-search-count');
  if(!status)return;
  const update=()=>{
    const words=input.value.trim().toLowerCase().split(/\s+/).filter(Boolean);
    let count=0;
    cards.forEach(card=>{card.hidden=!words.every(word=>card.dataset.search.includes(word));if(!card.hidden)count++;});
    root.querySelector('[data-no-results]').hidden=count>0;
    if(status)status.textContent=count+' '+(count===1?'piece':'pieces')+(words.length?' found':'');
  };
  input.value=new URLSearchParams(location.search).get('q')||'';
  input.addEventListener('input',update);
  input.addEventListener('keydown',event=>{if(event.key==='Escape'){input.value='';update();}});
  update();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx3-store-header"]) return;
  try {
    
document.querySelectorAll('[data-lx3-menu-trigger]').forEach(trigger=>{
  if(trigger.dataset.ready)return;
  trigger.dataset.ready='true';
  const dialog=document.getElementById(trigger.getAttribute('aria-controls'));
  if(!dialog)return;
  let savedY=0,closing=false,oldBodyStyle=null;
  const finish=()=>{
    dialog.close();dialog.classList.remove('is-closing');closing=false;
    trigger.setAttribute('aria-expanded','false');
    if(oldBodyStyle===null)document.body.removeAttribute('style');else document.body.setAttribute('style',oldBodyStyle);
    window.scrollTo(0,savedY);
    trigger.focus({preventScroll:true});
  };
  const close=()=>{
    if(!dialog.open||closing)return;
    closing=true;
    if(matchMedia('(prefers-reduced-motion: reduce)').matches){finish();return;}
    dialog.classList.add('is-closing');setTimeout(finish,160);
  };
  trigger.addEventListener('click',()=>{
    if(dialog.open){close();return;}
    savedY=window.scrollY;oldBodyStyle=document.body.getAttribute('style');
    document.body.style.position='fixed';document.body.style.top=-savedY+'px';document.body.style.width='100%';
    dialog.showModal();trigger.setAttribute('aria-expanded','true');
  });
  dialog.querySelector('[data-lx3-menu-close]').addEventListener('click',close);
  dialog.addEventListener('cancel',event=>{event.preventDefault();close();});
  dialog.addEventListener('click',event=>{if(event.target.closest('a'))close();});
  matchMedia('(min-width:701px)').addEventListener('change',event=>{if(event.matches&&dialog.open)close();});
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
